import React from 'react'
import { Box } from '@mui/material'
import DocumentList from '../../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../../Config/Config.js'
import LibraryData from '../../../Assets/JSON/AcademicData/Library/library.json'

const LibraryPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)',
        py: 2,
        px: { xs: 2, sm: 4 },
      }}
    >
      <DocumentList
        data={LibraryData}
        title="Library"
        basePath={IMAGE_BASE_PATH_DBRALC}
        navigatePath="/library"
        sx={{ mt: 2 }}
      />
    </Box>
  )
}

export default LibraryPage
